export default class ErrorHandler {
    static get middleware() {
        return (error) => {
            // TODO trigger fullstory/sentry tracking
            // console.error(error);
            throw error;
        };
    }
}
